/* eslint-disable @typescript-eslint/no-explicit-any */
import MenuIcon from "@mui/icons-material/Menu";
import { Fab, Typography, useMediaQuery } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useContext, useEffect, useMemo, useState } from "react";
import IconButton from "@mui/material/IconButton";
import SettingsIcon from "@mui/icons-material/Settings";
import styles from "../Styles/mainHeader.module.css";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import Logout from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import { localUrlEnum, urlEnum } from "../Utils/UrlEnum";
import { Vocabulary } from "../Utils/Vocabulary";
import {
  calculateDurationForInterval,
  logout,
  saveTimeTrackingToDatabase,
  showFormattedDuration,
} from "../Utils/Utils";
import { OrderContext } from "../Contexts/OrderContext";
import { getData } from "../Services/getData";
import moment from "moment";
import { Info } from "@mui/icons-material";
import { postData } from "../Services/postData";
import { HttpStatusCode } from "../Utils/Constants";
import { Step, TimeTracking } from "../Utils/Models";
import startIcon from "../assets/start.png";
import stopIcon from "../assets/stop.png";
import Notifications from "./GenericComponents/Notifications";

export default function MainHeader() {
  const phoneStyle = useMediaQuery("(max-width:800px)");
  const orderContext = useContext(OrderContext);
  const userId = useMemo(() => localStorage.getItem("userId"), []);
  const userName = localStorage.getItem("userName");
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [time, setTime] = useState<any>(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [timeTracking, setTimeTracking] = useState<any>(null);
  const [updateUseEffect, setUpdateUseEffect] = useState<boolean>(false);
  const [avoidPressButtonMultipleTimes, setAvoidPressButtonMultipleTimes] =
    useState<boolean>(false);
  const open = Boolean(anchorEl);

  /**
   *
   */
  useEffect(() => {
    getTimeTracking();
    if (timeTracking) {
      const intervalId = setInterval(() => calculateTime(), 1000);
      return () => clearInterval(intervalId);
    }
    setTime(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderContext.order, updateUseEffect]);

  /**
   *
   */
  async function getTimeTracking() {
    const response = await getData(
      `${urlEnum.timeTracking}/activeTimeTracking/${userId}`
    );
    if (response && response.data.result) {
      setTimeTracking(response.data.result);
      if (response.data.result._id !== timeTracking?._id) {
        setUpdateUseEffect(!updateUseEffect);
      }
    }
  }

  /**
   *
   * @param order
   * @param intervalWithoutEndTime
   */
  function calculateTime() {
    const interval = {
      startTime: timeTracking.startTime,
      endTime: moment().unix(),
    };
    const duration = calculateDurationForInterval(interval);
    const formattedDuration = showFormattedDuration(duration);
    setTime({
      orderText: timeTracking.orderId
        ? `Order: ${timeTracking.orderId.orderNumber} `
        : "No order",
      orderId: timeTracking.orderId ? timeTracking.orderId._id : null,
      time: `${formattedDuration}`,
    });
  }
  /**
   *
   * @param event
   */
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  /**
   *
   */
  const handleClose = () => {
    setAnchorEl(null);
  };

  /**
   *
   */
  const handleLogout = async () => {
    setAnchorEl(null);
    // const response: any = await getData(urlEnum.logout);
    // if (response && !response.errors) {
    logout();
    navigate(localUrlEnum.login);
    //}
  };

  /**
   *
   */
  const redirectToMyAccount = () => {
    navigate(localUrlEnum.myAccount);
    setAnchorEl(null);
  };

  /**
   *
   */
  const redirectToSettings = () => {
    navigate(localUrlEnum.settings);
    setAnchorEl(null);
  };
  /**
   * Start loading
   */
  function largeMenu() {
    const container = document.getElementById("container");
    container?.classList.remove("containerLarge");
    container?.classList.add("containerSmall");

    const mainSlider = document.getElementById("mainSlider");
    mainSlider?.classList.remove("mainSliderLarge");
    mainSlider?.classList.add("mainSliderSmall");

    document.documentElement.style.setProperty("--isSmall", "1");
  }

  /**
   * Stop loading
   */
  function smallMenu() {
    const container = document.getElementById("container");
    container?.classList.remove("containerSmall");
    container?.classList.add("containerLarge");

    const mainSlider = document.getElementById("mainSlider");
    mainSlider?.classList.remove("mainSliderSmall");
    mainSlider?.classList.add("mainSliderLarge");

    document.documentElement.style.setProperty("--isSmall", "0");
  }

  /**
   *
   */
  function openOrCloseMenu() {
    if (!openMenu) {
      largeMenu();
    } else {
      smallMenu();
    }
    setOpenMenu(!openMenu);
  }

  /**
   *
   * @param workflowSteps
   * @param userId
   * @returns
   */
  function findStepWithNullEndTime(workflowSteps: Array<Step>) {
    for (let i = 0; i < workflowSteps.length; i++) {
      const step: Step = workflowSteps[i];
      const timeTrackingIndex = step.timeTracking.findIndex(
        (timeTracking: TimeTracking) =>
          timeTracking.endTime === null && timeTracking?.userId?._id === userId
      );
      if (timeTrackingIndex >= 0) {
        const newTimeTracking = step.timeTracking.slice();
        newTimeTracking[timeTrackingIndex].endTime = moment().unix();
        return {
          stepIndex: i,
          timeTracking: newTimeTracking,
        };
      }
    }
    return null;
  }

  /**
   *
   * @returns
   */
  async function getOrder() {
    if (!orderContext.order._id) {
      if (timeTracking.orderId) {
        const res = await getData(
          `${urlEnum.orders}/${timeTracking.orderId._id}`
        );
        if (res) {
          return res.data.result;
        }
      }
    }
    if (orderContext.order._id) {
      return orderContext.order;
    }
    return null;
  }

  /**
   * Save time tracking
   */
  async function saveTimeTracking() {
    const newOrder = await getOrder();
    if (!newOrder) return;
    const activeStep: any = findStepWithNullEndTime(newOrder.workflowSteps);
    if (!activeStep) return;
    const response = await saveTimeTrackingToDatabase(
      newOrder._id || "",
      activeStep.stepIndex,
      activeStep.timeTracking
    );
    if (
      response &&
      (response.status === HttpStatusCode.OK ||
        response.status === HttpStatusCode.Created)
    )
      orderContext.setOrder({
        ...orderContext.order,
        workflowSteps: response.result,
      });
  }

  /**
   * Start time tracking
   */
  function startTimeTracking() {
    const newTimeTracking = {
      userId: userId,
      orderId: null,
      stepId: null,
      startTime: moment().unix(),
      endTime: null,
    };
    postData(`${urlEnum.timeTracking}`, newTimeTracking);
    setUpdateUseEffect(!updateUseEffect);
    setAvoidPressButtonMultipleTimes(true);
  }

  /**
   * Stop time tracking
   */
  async function stopTimeTracking() {
    setAvoidPressButtonMultipleTimes(false);
    if (timeTracking.orderId) {
      await saveTimeTracking();
    } else {
      await postData(`${urlEnum.timeTracking}/${timeTracking._id}`, {
        ...timeTracking,
        endTime: moment().unix(),
      });
    }
    setTimeTracking(null);
    setTime(null);
    setUpdateUseEffect(!updateUseEffect);
  }

  return (
    <>
      <div className={styles.container}>
        <div className={styles.secondContainer}>
          {phoneStyle ? null : (
            <div>
              <IconButton
                style={{ backgroundColor: "#fff" }}
                aria-label="add"
                onClick={openOrCloseMenu}
              >
                <MenuIcon />
              </IconButton>
            </div>
          )}
          <div style={{ marginLeft: 10 }}>
            <a href="/">
              <img src={"/logo.png"} alt="Cafe-Mag" width={"10%"} />
            </a>
          </div>
        </div>
        <div className={styles.secondContainer}>
          {time && !phoneStyle ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginRight: 10,
                backgroundColor: "#fff3",
                marginTop: -10,
                marginBottom: -10,
                padding: "0px 10px",
              }}
            >
              <img
                src={stopIcon}
                alt="Stop"
                height={"42px"}
                style={{ cursor: "pointer", marginRight: 10 }}
                onClick={stopTimeTracking}
              />

              <p
                style={{
                  color: "#0000005e",
                  padding: 0,
                  margin: 2,
                  marginRight: 10,
                }}
              >
                {time.time}
              </p>
              <p
                style={{
                  color: "#0000005e",
                  padding: 0,
                  margin: 2,
                  marginRight: 10,
                  cursor: time.orderId ? "pointer" : "default",
                }}
                onClick={() =>
                  time.orderId
                    ? navigate(`${localUrlEnum.orders}/${time.orderId}`)
                    : null
                }
              >
                {time.orderText}
              </p>
            </div>
          ) : null}
          {!time ? (
            <img
              src={startIcon}
              alt="Start"
              height={"42px"}
              style={{ cursor: "pointer", marginRight: 10 }}
              onClick={() =>
                !avoidPressButtonMultipleTimes ? startTimeTracking() : null
              }
            />
          ) : null}
          <Typography className={styles.username}>{userName}</Typography>
          <Notifications />
          <Fab
            onClick={handleClick}
            size="small"
            className={styles.fab}
            aria-label="add"
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <AccountCircleIcon />
          </Fab>

          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <MenuItem onClick={redirectToMyAccount}>
              <Avatar /> {Vocabulary.myAccount}
            </MenuItem>
            <Divider />
            <MenuItem onClick={redirectToSettings}>
              <ListItemIcon>
                <SettingsIcon />
              </ListItemIcon>
              {Vocabulary.settings}
            </MenuItem>
            <Divider />
            <MenuItem>
              <ListItemIcon>
                <Info fontSize="small" />
              </ListItemIcon>
              <a
                style={{ textDecoration: "none", color: "rgba(0, 0, 0, 0.80" }}
                href="/intro.html"
                target="_blank"
              >
                {Vocabulary.userManual}
              </a>
            </MenuItem>
            <Divider />
            <MenuItem onClick={handleLogout}>
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              {Vocabulary.logout}
            </MenuItem>
          </Menu>
        </div>
      </div>
      {time && phoneStyle ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#fff3",
            margin: "5px -10px -10px -10px",
            padding: "7px 10px",
          }}
        >
          <img
            src={stopIcon}
            alt="Stop"
            height={"42px"}
            style={{ cursor: "pointer", marginRight: 10 }}
            onClick={stopTimeTracking}
          />
          <p
            style={{
              color: "#0000005e",
              padding: 0,
              margin: 2,
              marginRight: 10,
            }}
          >
            {time.time}
          </p>
          <p
            style={{
              color: "#0000005e",
              padding: 0,
              margin: 2,
              marginRight: 10,
              cursor: "pointer",
            }}
            onClick={() => {
              navigate(`${localUrlEnum.orders}/${time.orderId}`);
            }}
          >
            {time.orderText}
          </p>
        </div>
      ) : null}
    </>
  );
}
